import {useTheme} from "@mui/material";
import { useTranslation } from "react-i18next";
import { LEISURE_AGREEMENT_STATUS_DISMISSED, LEISURE_AGREEMENT_STATUS_DRAFT, LEISURE_AGREEMENT_STATUS_READY } from "./Constants";

export const useStatusValuesLeisureAgreement = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();

    const getStatusColorAgreement = (status: string) => {
        switch (status) {
            case LEISURE_AGREEMENT_STATUS_READY: return theme.palette.success.transparent;
            case LEISURE_AGREEMENT_STATUS_DISMISSED: return theme.palette.error.transparent;
            case LEISURE_AGREEMENT_STATUS_DRAFT: return theme.palette.warning.transparent;
        }
    };

    const getStatusLabelAgreement = (status: string) => {
        switch (status) {
            case LEISURE_AGREEMENT_STATUS_READY: return t('salesmarketing:businessAgreement.statusValues.ready');
            case LEISURE_AGREEMENT_STATUS_DISMISSED: return t('salesmarketing:businessAgreement.statusValues.dismissed');
            case LEISURE_AGREEMENT_STATUS_DRAFT: return t('salesmarketing:businessAgreement.statusValues.draft');
        }
    };

    return {
        getStatusColorAgreement,
        getStatusLabelAgreement
    }
}